// extracted by mini-css-extract-plugin
module.exports = {"modal_root":"ReorderQuestions_modal_root__d-hDM","container":"ReorderQuestions_container__YUFMp","dragable_item":"ReorderQuestions_dragable_item__2I84z"};